import { useStageWords } from "../components/StageWords";
import { absent } from "../lib/format";
import { Word } from "./words";

/* A project's stage, as a meter and the team's word. Six segments for the six
   stages in order, filled to the stage, so progress is read without telling
   two shades of one color apart. A property with no project ("Existing
   building") and a dead project get the word alone. */
export function Stage({ word, order }: { word: string | null | undefined; order: number | null }) {
  if (!word) return <>{absent()}</>;
  if (order === null || order > 6) return <Word tone="quiet">{word}</Word>;
  return (
    <span className="stage" title={`Stage ${order} of 6`}>
      <span className="stage-meter" aria-hidden="true">
        {[1, 2, 3, 4, 5, 6].map((n) => <span key={n} className={n <= order ? "stage-seg on" : "stage-seg"} />)}
      </span>
      {word}
    </span>
  );
}

/** The order of a stage word in the team's list, from api.stage_word. */
export function useStageOrder(token: string) {
  const words = useStageWords(token);
  return {
    words: words.data ?? [],
    orderOf: (word: string | null | undefined): number | null => {
      if (!word || !words.data) return null;
      const at = words.data.findIndex((w) => w.word === word);
      return at < 0 ? null : at + 1;
    },
  };
}
